import React from "react"
import PropTypes from "prop-types"

const DropdownMenuItem = ({
  item,
  menu,
  getActiveHoveredState,
  setDropdownOptionHoverState,
  selectDropdownOption,
}) => {

  const isHovered = () => {
    const hovered = getActiveHoveredState()
    return item === hovered ? "hovered" : ''
  }

  const outputMenuItem = () => {
    return (
      <div
        data-item     = { item }
        onMouseOver   = { () => setDropdownOptionHoverState(menu, item) }
        onClick       = { () => selectDropdownOption(menu, item) }
        className     = { `drop-down-item selection ${isHovered()}` }
      >
        { item.label }
      </div>
    )
  }

  return (
    <div role="menu-item" tabIndex="0" className="drop-down-item-container">
      { outputMenuItem() }
    </div>
  )
}

DropdownMenuItem.propTypes = {
  item: PropTypes.object,
  menu: PropTypes.string,
  getActiveHoveredState: PropTypes.func,
  setDropdownOptionHoverState: PropTypes.func,
  selectDropdownOption: PropTypes.func,
}
export default DropdownMenuItem
